
import { Model } from 'caldera-immutable-model';

import Task from '../../models/Task';
import TaskCollection from '../../models/TaskCollection';
import SubTask from '../../models/SubTask';
import SubTaskCollection from '../../models/SubTaskCollection';

import type { TaskObject, SubTaskObject } from './types';

type TaskConvertible = TaskObject | Task;
type TaskCollectionConvertible = TaskObject[]
  | Task[]
  | TaskCollection;
type SubTaskConvertible = SubTaskObject | SubTask;
type SubTaskCollectionConvertible = SubTaskObject[] | SubTask[] | SubTaskCollection;

export default class TasksState extends Model {

  _tasks: TaskCollection;
  _subTasks: SubTaskCollection;

  constructor(data: any) {
    super(data);
    this._tasks = new TaskCollection(this.get('tasks'));
    this._subTasks = new SubTaskCollection(this.get('subTasks'));
  }

  // Events

  get tasks(): TaskCollection {
    return this._tasks;
  }

  setTasks(tasks: ?TaskCollectionConvertible): TasksState {
    return this.set('tasks', tasks);
  }

  addOrReplaceTask(task: TaskConvertible): TasksState {
    return this.setTasks(this.tasks.addOrReplaceById(task.id || task.uid, task));
  }

  // Fetching tasks

  get isFetchingTasks(): boolean {
    return !!this.get('isFetchingTasks');
  }

  setIsFetchingTasks(isFetching: boolean): TasksState {
    return this.set('isFetchingTasks', isFetching);
  }

  // Creating tasks

  get isCreatingTask(): boolean {
    return !!this.get('isCreatingTask');
  }

  setIsCreatingTask(isCreating: boolean): TasksState {
    return this.set('isCreatingTask', isCreating);
  }

  // Subtasks

  get subTasks(): SubTaskCollection {
    return this._subTasks;
  }

  setSubTasks(subTasks: ?SubTaskCollectionConvertible): TasksState {
    return this.set('subTasks', subTasks);
  }

  addOrReplaceSubTasks(subTasks: SubTaskCollectionConvertible): TasksState {
    let newSubTasks = this.subTasks;
    subTasks.forEach(subTask => {
      newSubTasks = newSubTasks.addOrReplaceById(subTask.id || subTask.uid, subTask);
    });
    return this.setSubTasks(newSubTasks);
  }

  addOrReplaceSubTask(subTask: SubTaskConvertible): TasksState {
    const subTasks = this.subTasks.addOrReplaceById(subTask.id || subTask.uid, subTask).removeDuplicates();
    return this.setSubTasks(subTasks);
  }

  removeSubTask(subTask: SubTaskConvertible): TasksState {
  return this.setSubTasks(this.subTasks.removeById(subTask.uid));
}

  // Creating subTask

  get isCreatingSubTask(): boolean {
    return !!this.get('isCreatingSubTask');
  }

  setIsCreatingSubTask(isCreating: boolean): TasksState {
    return this.set('isCreatingSubTask', isCreating);
  }

  // Fetching subTasks

  get isFetchingSubTasks(): boolean {
    return !!this.get('isFetchingSubTasks');
  }

  setIsFetchingSubTasks(isFetching: boolean): TasksState {
    return this.set('isFetchingSubTasks', isFetching);
  }
}



// WEBPACK FOOTER //
// ./src/redux/tasks/TasksState.js